/**
 * Board 5 · Switching a reply or a write on before it is Ready: what is not Ready and why, then the person keeps
 * asking or turns it on anyway. Turning on anyway is kept in History with their name.
 */

import {
	AlertDialog,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import type { NotReadyItem } from '@/modules/promotion/types';
import { notReadyEffectOf } from './view-rules';

interface NotReadyDialogProps {
	items: NotReadyItem[] | null;
	busy: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

export const NotReadyDialog = ({ items, busy, onConfirm, onCancel }: NotReadyDialogProps) => (
	<AlertDialog open={Boolean(items?.length)} onOpenChange={(open) => !open && onCancel()}>
		<AlertDialogContent>
			<AlertDialogHeader>
				<AlertDialogTitle>Turn on before it's Ready?</AlertDialogTitle>
				<AlertDialogDescription asChild>
					<div className='flex flex-col gap-3 text-[13px] text-gray-900'>
						<ul className='flex flex-col gap-2'>
							{items?.map((item) => (
								<li key={item.key} className='flex flex-col gap-0.5 rounded-lg border border-gray-300 px-3 py-2'>
									<span className='font-medium text-text-heading'>
										{item.tool ? `${item.tool} in ${item.description}` : item.description}
									</span>
									<span className='text-xs text-yellow-foreground'>Not Ready: {item.reason}</span>
									<span className='text-xs text-gray-800'>{notReadyEffectOf(item)}</span>
								</li>
							))}
						</ul>
						<p className='text-xs text-gray-800'>
							A later reject won't switch it off: it shows here and alerts the promotion channel. Your name and this
							evidence are saved in History.
						</p>
					</div>
				</AlertDialogDescription>
			</AlertDialogHeader>
			<AlertDialogFooter>
				<AlertDialogCancel disabled={busy}>Keep asking</AlertDialogCancel>
				<Button onClick={onConfirm} disabled={busy}>
					Turn on anyway
				</Button>
			</AlertDialogFooter>
		</AlertDialogContent>
	</AlertDialog>
);
